import { Component } from "react";

export default class SafeFx extends Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(err) { console.error("Visual effect disabled:", err); }
  render() { return this.state.failed ? null : this.props.children; }
}
